import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { isAuthenticatedFromCookies, DEFAULT_COOKIE_OPTS } from "../utils/constatnts";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const cookies = new Cookies();

  const [authState, setAuthState] = useState({
    user: {},
    isLoggedIn: false,
    appEmail: "https://www.debnow.com",
  });

  const [isPaymentBannerDismissed, setIsPaymentBannerDismissed] =
    useState(false);
  const [isPaymentIncomeAccountDismissed, setIsPaymentIncomeAccountDismissed] =
    useState(false);

  const handleUpdateAuthState = (updateData) => {
    setAuthState((prevState) => {
      return {
        ...prevState,
        ...updateData,
      };
    });
  };

  const handleUpdatePaymentBannerDismissed = (dismissed) => {
    setIsPaymentBannerDismissed(dismissed);
  };

  const handleUpdatePaymentIncomeAccountDismissed = (dismissed) => {
    setIsPaymentIncomeAccountDismissed(dismissed);
  };

  useEffect(() => {
    const userFromCookies = cookies.get("authUser", DEFAULT_COOKIE_OPTS) || {};
    const isLoggedIn = isAuthenticatedFromCookies(cookies);
    const appEmail = window.location.origin;
    setAuthState((prevState) => {
      return {
        ...prevState,
        user: userFromCookies,
        appEmail,
        isLoggedIn,
      };
    });
  }, []);

  return (
    <AuthContext.Provider
      value={{
        authState,
        handleUpdateAuthState,
        handleUpdatePaymentBannerDismissed,
        isPaymentBannerDismissed,
        isPaymentIncomeAccountDismissed,
        handleUpdatePaymentIncomeAccountDismissed,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;
